import { StreamState } from '@crew/enums/domain';
export const IsUpdatedMeetingRecordingStreamState = (v) => {
    if (typeof v !== 'object' || v === null)
        return false;
    const m = v;
    if (typeof m.eventRecordingId !== 'string')
        return false;
    if (typeof m.streamState !== 'string')
        return false;
    if (!Object.values(StreamState).includes(m.streamState))
        return false;
    return true;
};
